module.exports = __webpack_public_path__ + "img/tpb.bb8ba154.png";